'use client'

import classNames from 'classnames'
import React, { SVGProps, type JSX } from 'react'
import { icons } from './icons'
import { useTranslations } from '../hooks'

export type IconName = keyof typeof icons

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName
  className?: string
  multiLayered?: boolean
}

/** @deprecated Use `Icon` from `icon-library` instead. */
const Icon = ({
  name,
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => {
  const { translate } = useTranslations()

  const IconComponent = icons[name]

  return (
    <>
      {IconComponent ? (
        <IconComponent
          {...props}
          role="img"
          aria-label={props['aria-label'] || translate(`Icon_AriaLabel_${name}`)}
          className={classNames(`i-${name}`, className, {
            'i-multi-layered': multiLayered,
          })}
        />
      ) : null}
    </>
  )
}

export default Icon
